import { Component, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../../core/constants';
import { LocalstorageService } from '../../../services/localstorage.service';

@Component({
  selector: 'app-estimates',
  templateUrl: './estimates-container-pe.component.html',
  styleUrls: ['./estimates-container-pe.component.scss']
})
export class EstimatesComponent implements OnInit {
  @Input() selectedTabIndex: number = 0;
  locStorage = Constants.localStorageKeys;
  
  constructor(        
    private localstorageService: LocalstorageService,
    private router: Router
    ) 
    { 
      
    }

  ngOnInit() {
  }

  selectedTabChange(event: MatTabChangeEvent) {
    switch (event.index) {
      case 0: {
        console.log('Upload Estimates');
        this.router.navigate(['/bulkuploadestimates']);
        break;
      }
      case 1: {
        console.log('Estimate Requests List');
        this.router.navigate(['/estimaterequestpelist']);
        break;
      }
  }
    
  }
}
